import React, { Component } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import StickyBox from "react-sticky-box";

import classnames from 'classnames';

class CourseSection extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1'
        };
    }


    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    render() {
        return (
            <div>
                <Row>
                    <Col xs="6" sm="4" md="4" >
                        <StickyBox offsetTop={95}>
                            <Nav tabs vertical pills className="cards-sider">
                                <NavItem >
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '1' })}
                                        onClick={() => {
                                            this.toggle('1');
                                        }} >
                                        Data Science specialization (5)
                             </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '2' })}
                                        onClick={() => {
                                            this.toggle('2');
                                        }}
                                    >
                                        Six Sigma courses (6)
                            </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '3' })}
                                        onClick={() => {
                                            this.toggle('3');
                                        }}  >
                                        Online Course in Finance (3)
                            </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '4' })}
                                        onClick={() => {
                                            this.toggle('4');
                                        }}  >
                                        Technology courses (12)
                            </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '5' })}
                                        onClick={() => {
                                            this.toggle('5');
                                        }}  >
                                        Cyber Security (2)
                            </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: this.state.activeTab === '6' })}
                                        onClick={() => {
                                            this.toggle('6');
                                        }}  >
                                        Online Certification Courses (29)
                            </NavLink>
                                </NavItem>
                            </Nav>
                        </StickyBox>
                    </Col>
                    <Col xs="6" sm="6" md="8">
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="1">
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link class="bts" to="course/post-graduate-program-in-data-science">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/course-data-science-landing.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Classroom Course </p>
                                                    </div>
                                                    <div class="card-body-data-Science">
                                                        <p class="card-header-text">Post Graduate Program in Data Science</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 6 Months </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/post-graduate-program-in-data-science');" to="course/post-graduate-program-in-data-science" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link class="bts" to="course/post-graduate-program-in-data-analytics">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/dataanalyt.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Classroom Course </p>
                                                    </div>
                                                    <div class="card-body-Data-analytics">
                                                        <p class="card-header-text">Post Graduate Program in Data Analytics</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 4 Months </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/post-graduate-program-in-data-analytics');" to="course/post-graduate-program-in-data-analytics" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link class="bts" to="course/post-graduate-program-in-data-engineering">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/statistics.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Classroom Course </p>
                                                    </div>
                                                    <div class="card-body-data-engineering">
                                                        <p class="card-header-text">Post Graduate Program in Data Engineering</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 3 Months</span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/post-graduate-program-in-data-engineering');" to="course/post-graduate-program-in-data-engineering" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link class="bts" to="course/online-machine-learning-course">
                                                    <div class="card-img">
                                                        <img alt="datascience3" src="/assets/images/course/machine-learning.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Machine Learning </p> <br />
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 06:39:23 </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/online-machine-learning-course');" to="course/online-machine-learning-course" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link class="bts" to="course/certificate-course-in-machine-learning-using-python">
                                                    <div class="card-img">
                                                        <img
                                                            src="/assets/images/course/machine_learning1.jpg" loading="lazy" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="baground-mob-python">
                                                        <p class="card-header-text">Certificate Course in Machine Learning using Python </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"><i class="fa fa-clock-o" aria-hidden="true"></i>80 hours</span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-machine-learning-using-python');" to="course/certificate-course-in-machine-learning-using-python" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane tabId="2">
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link class="bts" to="course/executive-overview-six-sigma-program">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/execute-six-sigma.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-Executive">
                                                        <p class="card-header-text">Executive Overview Six Sigma Program</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 2 Days </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/executive-overview-six-sigma-program');" to="course/executive-overview-six-sigma-program" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link class="bts" to="course/six-sigma-master-black-belt-certification-program">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/six-sigma-master-black.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="baground-mob-mangodb">
                                                        <p class="card-header-text">Six Sigma Master Black Belt Certification Program</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 12 Days </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/six-sigma-master-black-belt-certification-program');" to="course/six-sigma-master-black-belt-certification-program" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/lean-six-sigma-supplement" class="bts">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/lean-six-sigma.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-Lean">
                                                        <p class="card-header-text">Lean Six Sigma Supplement </p>
                                                        <br />
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 3 Days </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/lean-six-sigma-supplement');" to="course/lean-six-sigma-supplement" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link class="bts" to="course/six-sigma-green-belt-certification-online">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/six-sigma-green.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-Green">
                                                        <p class="card-header-text">Six Sigma Green Belt Certification Program</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 5 Days </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/six-sigma-green-belt-certification-online');" to="course/six-sigma-green-belt-certification-online" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/six-sigma-yellow-belt-program" class="bts">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/six-sigma-yellow.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-Yellow">
                                                        <p class="card-header-text">Six Sigma Yellow Belt Program</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 2 Days </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/six-sigma-yellow-belt-program');" to="course/six-sigma-yellow-belt-program" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/six-sigma-black-belt-certification-program" class="bts">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/black-belt.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-Black">
                                                        <p class="card-header-text">Six Sigma Black Belt Certification Program </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 12 Days </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/six-sigma-black-belt-certification-program');" to="course/six-sigma-black-belt-certification-program" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane tabId="3">
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/valuation" class="bts">
                                                    <div class="card-img">
                                                        <img
                                                            src="/assets/images/course/Valuation-level1.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-Lean">
                                                        <p class="card-header-text">Valuation</p><br />
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"><i class="fa fa-clock-o" aria-hidden="true"></i> 04:13:11</span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/valuation');" to="course/valuation" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/financial-statements-analysis-course" class="bts">
                                                    <div class="card-img">
                                                        <img
                                                            src="/assets/images/course/Understanding-Financial-Statement.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Financial Statements Analysis Course </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"><i class="fa fa-clock-o" aria-hidden="true"></i>  03:49:28 </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/financial-statements-analysis-course');" to="course/financial-statements-analysis-course" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/insolvency-and-bankruptcy-code" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/Insolvency-and-Bankruptcy-code.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Insolvency and Bankruptcy Code </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 04:20:26 </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/insolvency-and-bankruptcy-code');" class="btn btn-md btn-know-more" to="course/insolvency-and-bankruptcy-code">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane tabId="4">
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-sql" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/mysql.jpg" loading="lazy" class="lazyload" alt="SQL" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in SQL</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i>30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-sql');" class="btn btn-md btn-know-more" to="course/certificate-course-in-sql">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-mongoDB" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/mongodbAtlas.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in MongoDB</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i>30 HOURS  </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-mongoDB');" class="btn btn-md btn-know-more" to="course/certificate-course-in-mongoDB">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-big-data-hadoop" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/hadoop.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate course in Big Data Hadoop </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 36 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-big-data-hadoop');" class="btn btn-md btn-know-more" to="course/certificate-course-in-big-data-hadoop">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-python-programming" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/python.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate course in Python Programming </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-python-programming');" class="btn btn-md btn-know-more" to="course/certificate-course-in-python-programming">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-spark" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/spark.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate course in Spark </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-spark');" class="btn btn-md btn-know-more" to="course/certificate-course-in-spark">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-cloud-computing" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/aws.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in Cloud Computing </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-cloud-computing');" class="btn btn-md btn-know-more" to="course/certificate-course-in-cloud-computing">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-data-analytics-using-r-programing" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/crslogo-44-min.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in Data Analytics using R Programing </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-data-analytics-using-r-programing');" class="btn btn-md btn-know-more" to="course/certificate-course-in-data-analytics-using-r-programing">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-advance-excel" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/advanceexcel-min.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in Advance Excel </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 24 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-advance-excel');" class="btn btn-md btn-know-more" to="course/certificate-course-in-advance-excel">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-data-visualizaton-using-power-bi" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/power-bi-min.png" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate course in Data Visualizaton using Power BI</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-data-visualizaton-using-power-bi');" class="btn btn-md btn-know-more" to="course/certificate-course-in-data-visualizaton-using-power-bi">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-data-visualiztion-using-tableau" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/icons/tableau2.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in Data Visualization using Tableau </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-data-visualiztion-using-tableau');" class="btn btn-md btn-know-more" to="course/certificate-course-in-data-visualiztion-using-tableau">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-machine-learning-using-python" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/machine_learning1.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in Machine Learning using Python</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 80 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-machine-learning-using-python');" class="btn btn-md btn-know-more" to="course/certificate-course-in-machine-learning-using-python">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-deep-learning-using-tensorflow" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/deep-learning.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in Deep Learning using Tensorflow</p><br />
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-deep-learning-using-tensorflow');" class="btn btn-md btn-know-more" to="course/certificate-course-in-deep-learning-using-tensorflow">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane tabId="5">
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-in-cyber-crime-analysis" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/Understanding-Financial-Statement.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Cyber Crime Analysis</p><br /><br />
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 7 HOURS Videos </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-in-cyber-crime-analysis');" class="btn btn-md btn-know-more" to="course/certificate-in-cyber-crime-analysis">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/online-cyber-security-certification" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/cyber-security-Awareness.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Cyber Security Certification</p><br /><br />
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 7 HOURS Videos </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/online-cyber-security-certification');" class="btn btn-md btn-know-more" to="course/online-cyber-security-certification">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane tabId="6">
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/post-graduate-program-in-data-science" class="bts">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/course-data-science-landing.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Classroom Course </p>
                                                    </div>
                                                    <div class="card-body-data-Science">
                                                        <p class="card-header-text">Post Graduate Program in Data Science</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 6 Months </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/post-graduate-program-in-data-science');" to="course/post-graduate-program-in-data-science" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/post-graduate-program-in-data-analytics" class="bts">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/dataanalyt.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Classroom Course </p>
                                                    </div>
                                                    <div class="card-body-Data-analytics">
                                                        <p class="card-header-text">Post Graduate Program in Data Analytics</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 4 Months </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/post-graduate-program-in-data-analytics');" to="course/post-graduate-program-in-data-analytics" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/post-graduate-program-in-data-engineering" class="bts" >
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/statistics.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Classroom Course </p>
                                                    </div>
                                                    <div class="card-body-data-engineering">
                                                        <p class="card-header-text">Post Graduate Program in Data Engineering</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 3 Months</span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/post-graduate-program-in-data-engineering');" to="course/post-graduate-program-in-data-engineering" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/executive-overview-six-sigma-program" class="bts">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/execute-six-sigma.jpg" class="lazyload " />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-Executive">
                                                        <p class="card-header-text">Executive Overview Six Sigma Program</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 2 Days </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/executive-overview-six-sigma-program');" to="course/executive-overview-six-sigma-program" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/lean-six-sigma-supplement" class="bts">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/lean-six-sigma.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-Lean">
                                                        <p class="card-header-text">Lean Six Sigma Supplement </p>
                                                        <br />
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 3 Days </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/lean-six-sigma-supplement');" to="course/lean-six-sigma-supplement" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/six-sigma-master-black-belt-certification-program" class="bts">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/six-sigma-master-black.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="baground-mob-mangodb">
                                                        <p class="card-header-text">Six Sigma Master Black Belt Certification Program</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 12 Days </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/six-sigma-master-black-belt-certification-program');" to="course/six-sigma-master-black-belt-certification-program" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/six-sigma-green-belt-certification-online" class="bts">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/six-sigma-green.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-Green">
                                                        <p class="card-header-text">Six Sigma Green Belt Certification Program</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 5 Days </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/six-sigma-green-belt-certification-online');" to="course/six-sigma-green-belt-certification-online" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/six-sigma-yellow-belt-program" class="bts">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/six-sigma-yellow.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-Yellow">
                                                        <p class="card-header-text">Six Sigma Yellow Belt Program</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 2 Days </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/six-sigma-yellow-belt-program');" to="course/six-sigma-yellow-belt-program" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/six-sigma-black-belt-certification-program" class="bts">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/black-belt.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-Black">
                                                        <p class="card-header-text">Six Sigma Black Belt Certification Program </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 12 Days </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/six-sigma-black-belt-certification-program');" to="course/six-sigma-black-belt-certification-program" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/financial-statements-analysis-course" class="bts">
                                                    <div class="card-img">
                                                        <img
                                                            src="/assets/images/course/Understanding-Financial-Statement.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Financial Statements Analysis Course </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"><i class="fa fa-clock-o" aria-hidden="true"></i>  03:49:28 </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/financial-statements-analysis-course');" to="course/financial-statements-analysis-course" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/statistics-for-researchers-course" class="bts">
                                                    <div class="card-img">
                                                        <img alt="datascience3"
                                                            src="/assets/images/course/statistics.jpg" class="lazyload" />
                                                        <p class="card-text-over-img">Classroom Course </p>
                                                    </div>
                                                    <div class="card-body-Statistics">
                                                        <p class="card-header-text">Statistics for Researchers</p>
                                                        <br />
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"> 3 Days </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/statistics-for-researchers-course');" to="course/statistics-for-researchers-course" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/valuation" class="bts">
                                                    <div class="card-img">
                                                        <img
                                                            src="/assets/images/course/Valuation-level1.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-Lean">
                                                        <p class="card-header-text">Valuation </p><br />
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"><i class="fa fa-clock-o" aria-hidden="true"></i> 04:13:11</span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/valuation');" to="course/valuation" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-sql" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/mysql.jpg" loading="lazy" class="lazyload" alt="SQL" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in SQL</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i>30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-sql');" class="btn btn-md btn-know-more" to="course/certificate-course-in-sql">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-mongoDB" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/mongodbAtlas.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in MongoDB</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i>30 HOURS  </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-mongoDB');" class="btn btn-md btn-know-more" to="course/certificate-course-in-mongoDB">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-big-data-hadoop" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/hadoop.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate course in Big Data Hadoop </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 36 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-big-data-hadoop');" class="btn btn-md btn-know-more" to="course/certificate-course-in-big-data-hadoop">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-python-programming" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/python.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate course in Python Programming </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-python-programming');" class="btn btn-md btn-know-more" to="course/certificate-course-in-python-programming">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-spark" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/spark.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate course in Spark </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-spark');" class="btn btn-md btn-know-more" to="course/certificate-course-in-spark">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-cloud-computing" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/aws.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in Cloud Computing </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-cloud-computing');" class="btn btn-md btn-know-more" to="course/certificate-course-in-cloud-computing">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-data-analytics-using-r-programing" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/crslogo-44-min.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in Data Analytics using R Programing </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-data-analytics-using-r-programing');" class="btn btn-md btn-know-more" >Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-advance-excel" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/advanceexcel-min.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in Advance Excel </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 24 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-advance-excel');" class="btn btn-md btn-know-more" to="course/certificate-course-in-advance-excel">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-data-visualizaton-using-power-bi" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/power-bi-min.png" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate course in Data Visualizaton using Power BI</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-course-in-data-visualizaton-using-power-bi');" class="btn btn-md btn-know-more" to="course/certificate-course-in-data-visualizaton-using-power-bi">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-data-visualiztion-using-tableau" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/icons/tableau2.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in Data Visualization using Tableau </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link class="btn btn-md btn-know-more" >Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-course-in-machine-learning-using-python" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/machine_learning1.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in Machine Learning using Python</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 80 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link class="btn btn-md btn-know-more" to="course/certificate-course-in-machine-learning-using-python">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link  to="course/certificate-course-in-deep-learning-using-tensorflow" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/deep-learning.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Certificate Course in Deep Learning using Tensorflow</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 30 HOURS </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link class="btn btn-md btn-know-more" to="course/certificate-course-in-deep-learning-using-tensorflow">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link  to="course/online-machine-learning-course"  class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/machine-learning.jpg" alt="datascience3"
                                                            class="lazyload" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Machine Learning </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 06:39:23 </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/online-machine-learning-course');" to="course/online-machine-learning-course" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/signal-processing-using-matlab" class="bts">
                                                    <div class="card-img">
                                                        <img src="assets/images/course/signal-Processing.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-Lean">
                                                        <p class="card-header-text">Signal Processing Using MATLAB </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 07:27:52 </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/signal-processing-using-matlab');" to="course/signal-processing-using-matlab" class="btn btn-md btn-know-more">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/insolvency-and-bankruptcy-code" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/Insolvency-and-Bankruptcy-code.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Insolvency and Bankruptcy Code </p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 04:20:26 </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/insolvency-and-bankruptcy-code');" class="btn btn-md btn-know-more" to="course/insolvency-and-bankruptcy-code">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/online-cyber-security-certification" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/cyber-security-Awareness.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-Lean">
                                                        <p class="card-header-text">CyberSecurity Awareness</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month"><i class="fa fa-clock-o" aria-hidden="true"></i> 06:59:03</span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link class="btn btn-md btn-know-more" onclick="return gtag_report_conversion('course/online-cyber-security-certification');" to="course/online-cyber-security-certification">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row pb-lg-4">
                                    <div class="col-lg-1 col-3 col-sm-3 col-md-3"></div>
                                    <div class="col-lg-5 col-8 col-sm-8 col-md-8">
                                        <div class="item">
                                            <div class="card">
                                                <Link to="course/certificate-in-cyber-crime-analysis" class="bts">
                                                    <div class="card-img">
                                                        <img src="/assets/images/course/Understanding-Financial-Statement.jpg" class="lazyload" alt="Oops" />
                                                        <p class="card-text-over-img">Online Course </p>
                                                    </div>
                                                    <div class="card-body-ml">
                                                        <p class="card-header-text">Cyber Crime Analysis</p>
                                                    </div>
                                                </Link>
                                                <div class="card-footer">
                                                    <div class="row">
                                                        <div class="col-6 text-left">
                                                            <ul class="card-ul">
                                                                <li><span class="duration">Duration</span></li>
                                                                <li><span class="month" ><i class="fa fa-clock-o" aria-hidden="true"></i> 7 HOURS Videos </span> </li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-6 text-right">
                                                            <ul class="card-ul">
                                                                <li><Link onclick="return gtag_report_conversion('course/certificate-in-cyber-crime-analysis');" class="btn btn-md btn-know-more" to="course/certificate-in-cyber-crime-analysis">Know More </Link> </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </TabPane>
                        </TabContent>
                    </Col>
                </Row>
                <section class="our-courses-featured">
                    <div id="stop-sticky"></div>
                </section>
            </div>
        );
    }
}

export default CourseSection;